import { getLabelMessage } from '@gef-ui/localization/messages';
import PropTypes from 'prop-types';
import React, { cloneElement, forwardRef, isValidElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { hasPermissionByWholeStructure } from '../../selectors';
import { useDefaultCduUserValue } from '../utils';
const COMPONENT_NAME = 'AccessControl';
const defaultAccessDeniedComponent = /*#__PURE__*/ React.createElement("div", null, getLabelMessage('common:accessDenied'));
const AccessControl = /*#__PURE__*/ forwardRef((inProps, ref)=>{
    const props = useDefaultCduUserValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { showAccessDenied = true, accessDeniedComponent = defaultAccessDeniedComponent, permissionResolver = hasPermissionByWholeStructure, children, accessLevel, throwError, ...other } = props;
    const hasPermissions = useSelector(permissionResolver)(accessLevel);
    useEffect(()=>{
        if (!hasPermissions && throwError) {
            throw new Error("user don't have required permissions");
        }
    }, [
        hasPermissions,
        throwError
    ]);
    if (hasPermissions) {
        if (/*#__PURE__*/ isValidElement(children)) {
            return /*#__PURE__*/ cloneElement(children, {
                ref,
                ...other
            });
        }
        return children;
    }
    if (showAccessDenied) {
        return accessDeniedComponent;
    }
    // If I want to return null, than this function is not a Component because there is not jsx. Weird.
    return /*#__PURE__*/ React.createElement(React.Fragment, null);
});
AccessControl.displayName = 'AccessControl';
AccessControl.propTypes = {
    accessDeniedComponent: PropTypes.node,
    accessLevel: PropTypes.any,
    children: PropTypes.node.isRequired,
    /**
	 * Function that resolves if user has correct permissions. Expected curried function.
	 *
	 * @param {Object} state - redux store
	 * @param {Object} accessLevel - accessLevel prop
	 * @returns {Boolean} true/false
	 */ permissionResolver: PropTypes.func,
    showAccessDenied: PropTypes.bool,
    /**
	 * Throw error when user has no permission. Use this when you want to kill application.
	 */ throwError: PropTypes.bool
};
export default AccessControl;
